import React from 'react';
import styled from 'styled-components';
import closeIconImg from 'images/close_icon.png';
import checkIconImg from 'images/check_icon-16x12.png'
export default function SurveyLocationModal({items, selectedLocation, onCancel, onComplete}) {

  const handleClose = (e) => {
    if(onCancel && e.currentTarget === e.target)
    {
      onCancel();
    }
  }
  const handleSelect = (e)=>{
    if(onComplete)
    {
      let targetNo = e.currentTarget.getAttribute("data-location-no");
      onComplete(targetNo);
    }
  }
  return(
    <ModalWrapper onClick={handleClose}>
      <ModalSection>
        <ModalHeader>
          <span></span>
          <HeaderTitle>지역선택</HeaderTitle>
          <CloseBtn >
            <img src={closeIconImg} onClick={handleClose} alt={'close modal button'}/>
          </CloseBtn>
        </ModalHeader>
        <ModalBody>
          {items.map((value, index)=>{
            return(
              <LocationItem key={`location-item-no-${value['no']}`} data-location-no={value['no']} onClick={handleSelect} >
                <ItemLeft></ItemLeft>
                  <LocationTxt>{value['name']}</LocationTxt>
                <ItemRight>
                {
                  (selectedLocation?.no &&selectedLocation['no'] === value['no'])
                  ?(<span><img src={checkIconImg} alt={'current location checker'}/></span>)
                  :(null)}
                </ItemRight>
              </LocationItem>);
          })}
        </ModalBody>
      </ModalSection>
    </ModalWrapper>
  );
}

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left:0;
  height: 100vh;
  width : 100%;
  background: #12121266;
  z-index:350;
`;

const ModalSection = styled.div`
  position: absolute;
  bottom: 0;
  background: #ffffff;
  height: 65vh;
  border-radius: 14px 14px 0px 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
`

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding : calc(100vw * (22 / 375)) calc(100vw * (20 / 375)) calc(100vw * (4 / 375));
  align-items: center;
  flex: 0 1 auto;
`;
const HeaderTitle = styled.div`
  display: inline-block;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
  line-height: calc(100vw * (26 / 375));
  color: #121212;
`;
const CloseBtn = styled.span`
  display: inline-block;
  width:calc(100vw * (14 / 375));
  height:calc(100vw * (14 / 375));
  cursor: pointer;
`;

const ModalBody = styled.div`
  flex: 0 1 auto;
  height: 100%;
  overflow-y: scroll;
`;
const LocationItem = styled.div`
  position :relative;
  padding : calc(100vw * (16 / 375)) 0;
  text-align: center;
`;
const LocationTxt = styled.span`
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (23 / 375));
  color: #4E4E4E;
`;
const ItemLeft = styled.span``;
const ItemRight = styled.span`
  position: absolute;
  right:calc(100vw * (20 / 375));
`;